module.exports = __webpack_public_path__ + "static/media/planet.045bbc50.png";